import { Component } from "react";

export default class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error) {
        console.error("App crashed:", error);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="flex min-h-screen items-center justify-center bg-paper p-8 text-center">
                    <div>
                        <p className="font-display text-4xl uppercase text-diner">
                            Ada yang hangat!
                        </p>
                        <p className="mt-3 text-ink/70">
                            refresh halaman ini untuk kembali.
                        </p>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}
